import React, { useEffect, useState } from "react";
import axios from "axios";

const AllBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBookings = async () => {
        try {
          const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/get-all-data`);
          setBookings(res.data.data);
        } catch (error) {
          console.error("Error fetching bookings:", error);
        } finally {
          setLoading(false);
        }
      };
      

    fetchBookings();
  }, []);

  if (loading) {
    return <div className="text-center mt-10">Loading...</div>;
  }

  return (
    <div className="container mx-auto p-4 mt-10">
      <h1 className="text-2xl font-bold mb-6 text-center">All Bookings</h1>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-300">
          <thead>
            <tr className="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
              <th className="py-3 px-6 text-left">Full Name</th>
              <th className="py-3 px-6 text-left">ID Type</th>
              <th className="py-3 px-6 text-left">ID Last 4</th>
              <th className="py-3 px-6 text-left">Address</th>
              <th className="py-3 px-6 text-left">Email</th>
              <th className="py-3 px-6 text-left">Mobile</th>
              <th className="py-3 px-6 text-left">Service ID</th>
              <th className="py-3 px-6 text-left">Created At</th>
            </tr>
          </thead>
          <tbody className="text-gray-700 text-sm">
            {bookings.map((booking) => (
              <tr key={booking._id} className="border-b border-gray-200 hover:bg-gray-100">
                <td className="py-3 px-6 text-left">{booking.full_name}</td>
                <td className="py-3 px-6 text-left">{booking.idType}</td>
                <td className="py-3 px-6 text-left">{booking.idLast4}</td>
                <td className="py-3 px-6 text-left">{booking.address}</td>
                <td className="py-3 px-6 text-left">{booking.email}</td>
                <td className="py-3 px-6 text-left">{booking.mobile}</td>
                <td className="py-3 px-6 text-left">{booking.serviceId}</td>
                <td className="py-3 px-6 text-left">
                  {new Date(booking.createdAt).toLocaleDateString()} {" "}
                  {new Date(booking.createdAt).toLocaleTimeString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllBookings;
